import { FC, useCallback, useEffect, useMemo } from 'react';
import { Form as Filter } from '@components/Form';

import { FilterFromProps } from './types';

export const FilterForm: FC<FilterFromProps> = ({ filterSchema, initialState, rows, table }) => {
    const fieldFields = useMemo(() => filterSchema.reduce((acc, cur) => ({ ...acc, [cur.name]: cur }), {}), [filterSchema]);
    Object.keys(fieldFields).forEach((key) => {
        if (
            fieldFields[key].type === 'select' ||
            (fieldFields[key].type === 'checkbox' && fieldFields[key].checkboxtype !== 'single') ||
            fieldFields[key].type === 'radio' ||
            fieldFields[key].type === 'radio-group' ||
            fieldFields[key].type === 'checkbox-group'
        ) {
            if (fieldFields[key].options === undefined || fieldFields[key].options.length === 0) {
                const options = [{ label: 'All', value: '' }];
                rows.forEach((row) => {
                    const data = { label: row.original[key], value: row.original[key] };
                    if (!options.some((x) => x.value === row.original[key])) {
                        options.push(data);
                    }
                });
                fieldFields[key].options = options;
            }
        }
    });

    const handleFilterSubmit = useCallback(
        (values) => {
            Object.keys(values).forEach((key) => {
                if (key === 'global' || key === 'find') {
                    table.setGlobalFilter(values[key] || undefined);
                } else if (typeof values[key] === 'string' || values[key] instanceof String) {
                    if (values[key].toString().toLowerCase() === 'all') {
                        table.getColumn(key)?.setFilterValue('');
                    } else {
                        table.getColumn(key)?.setFilterValue(values[key]);
                    }
                } else if (typeof values[key] === 'boolean' || values[key] instanceof Boolean) {
                    table.getColumn(key)?.setFilterValue(values[key] === true ? 'Yes' : '');
                } else if (values[key].value) {
                    table.getColumn(key)?.setFilterValue(values[key].value);
                } else if (values[key].value === '') {
                    table.getColumn(key)?.setFilterValue(null);
                } else if (values[key] && (values[key].from || values[key].to)) {
                    //range filter
                    table.getColumn(key)?.setFilterValue((old = []) => [values[key].from ? parseFloat(values[key].from) : '', old[1]]);
                    table.getColumn(key)?.setFilterValue((old = []) => [old[0], values[key].to ? parseFloat(values[key].to) : '']);
                } else if (values[key] && (values[key].startDate || values[key].endDate)) {
                    //range filter
                    //range filter
                    table
                        .getColumn(key)
                        ?.setFilterValue((old = []) => [
                            values[key].startDate && values[key].startDate.length > 0 ? values[key].startDate : undefined,
                            old[1],
                        ]);
                    table
                        .getColumn(key)
                        ?.setFilterValue((old = []) => [
                            old[0],
                            values[key].endDate && values[key].endDate.length > 0 ? values[key].endDate : undefined,
                        ]);
                } else if (values[key]) {
                    if (Array.isArray(values[key])) {
                        const filterValues = Array<string>();
                        values[key].forEach((val) => {
                            filterValues.push(val);
                        });
                        table.getColumn(key)?.setFilterValue(filterValues);
                    }
                }
            });
        },
        [table],
    );

    useEffect(() => {
        if (initialState) {
            handleFilterSubmit(initialState);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Filter
            fields={filterSchema}
            onSubmit={handleFilterSubmit}
            onChange={handleFilterSubmit}
            actionLabel="Search"
            initialState={initialState}
        />
    );
};

export default FilterForm;
